import { api } from './axios'

/**
 * Patient endpoints (Phase 1 — personal details only).
 * Backend reference: /patients
 */
export const patientApi = {
  /** POST /patients — create new patient (auto-assigns RD000PTxxx id) */
  create: (payload) => api.post('/patients', payload).then((r) => r.data),

  /** GET /patients — list/search */
  list: ({ search, limit = 50, offset = 0 } = {}, opts = {}) =>
    api
      .get('/patients', { params: { search, limit, offset }, ...opts })
      .then((r) => r.data),

  /** GET /patients/:id */
  get: (id) => api.get(`/patients/${id}`).then((r) => r.data),

  /** PATCH /patients/:id/personal-info — ONLY for the dedicated update button */
  updatePersonalInfo: (id, payload) =>
    api.patch(`/patients/${id}/personal-info`, payload).then((r) => r.data),

  /** DELETE /patients/:id */
  remove: (id) => api.delete(`/patients/${id}`).then((r) => r.data),
}
